/**
 * ADM-14 / BE-02。運転者の登録・編集で選べる機器の候補。
 *
 * サーバーが運転者へ割り当てられるのは、状態が「利用可能」で利用者のいない機器と、
 * その運転者がすでに使っている機器だけ（serializers.py の _assert_assignable）。
 * 「利用者なし」だけで絞ると修理中・故障の機器も候補に出て、保存すると
 * 400（device_not_available）になっていた。
 */
export function assignableDevices<T extends { user: number | null; status: string }>(
  devices: T[],
  driverId?: number
): T[] {
  return devices.filter(
    (device) =>
      (device.user === null && device.status === 'available') ||
      (driverId !== undefined && device.user === driverId)
  );
}
